// extracted by mini-css-extract-plugin
export var phone = "_12-0";